import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from '@/components/layout/Layout';
import { AuthProvider } from '@/contexts/AuthContext';
import { PrivateRoute } from '@/components/auth';
import { HomePage } from '@/pages/Home';
import { PricingPage } from '@/pages/Pricing';
import { ContactPage } from '@/pages/Contact';
import { DocsPage } from '@/pages/Docs';
import { FAQPage } from '@/pages/FAQ';
import { LearningPage } from '@/pages/Learning';
import { LoginPage, RegisterPage } from '@/pages/Auth';
import { DashboardPage } from '@/pages/Dashboard';
import { AppsPage } from '@/pages/Apps';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* 认证页面（无Layout） */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          
          {/* 私有页面（无Layout） */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <DashboardPage />
              </PrivateRoute>
            }
          />

          {/* AI编程训练营（需要登录，有Layout） */}
          <Route
            path="/learning"
            element={
              <PrivateRoute>
                <Layout>
                  <LearningPage />
                </Layout>
              </PrivateRoute>
            }
          />

          {/* 公共页面（有Layout） */}
          <Route path="/*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/apps" element={<AppsPage />} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route path="/docs" element={<DocsPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/contact" element={<ContactPage />} />
              </Routes>
            </Layout>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;